import { useEffect } from "react";
import tutorial from "../../components/canvas/core/tutorial";

const useSqftTutorial = ({
                           visualizersLoaded,
                           sqftVisited,
                           quotes,
                           activeQuoteIndex,
                           fabricatorData,
                         }) => {
  useEffect(() => {
    const activeQuote =
      quotes && Number.isInteger(activeQuoteIndex) ? quotes[activeQuoteIndex] : null;

    if (
      visualizersLoaded?.length &&
      !sqftVisited &&
      activeQuote &&
      !activeQuote.sqFtCalcData &&
      fabricatorData?.settings?.showSqftTutorial
    ) {
      tutorial.init();
    }
  }, [visualizersLoaded, sqftVisited, fabricatorData, quotes, activeQuoteIndex]);
};

export default useSqftTutorial;
